"use client";

import { ChefHat, User } from "lucide-react";
import { Dispatch, SetStateAction } from "react";

const SelectOptionComponent = ({
  setRegisteredRole,
}: {
  setRegisteredRole: Dispatch<SetStateAction<string | null>>;
}) => {
  return (
    <div className="flex flex-col md:flex-row items-end md:items-center justify-between rounded-2xl space-y-6 md:space-y-0 font-Inter">
      <button
        onClick={() => {
          localStorage.setItem("customerForm", "customer");
          setRegisteredRole("customer");
        }}
        className="flex flex-col items-center justify-center gap-1 border border-primary dark:border-secondary rounded-xl p-1 md:p-2 hover:bg-blue-50 dark:hover:bg-green-800 transition shadow-sm hover:shadow-lg cursor-pointer bg-secondary dark:bg-primary "
      >
        <User size={40} className="text-primary dark:text-secondary" />
        <span className="md:text-lg text-primary dark:text-secondary">
          Register as <br /> Customer
        </span>
      </button>

      <button
        onClick={() => {
          localStorage.setItem("mealProviderForm", "mealProvider");
          setRegisteredRole("mealProvider");
        }}
        className="flex flex-col items-center justify-center gap-1 border border-primary dark:border-secondary rounded-xl p-1 md:p-2 hover:bg-blue-50 dark:hover:bg-green-800 transition shadow-sm hover:shadow-lg cursor-pointer bg-secondary dark:bg-primary"
      >
        <ChefHat size={40} className="text-primary dark:text-secondary" />
        <span className="md:text-lg text-primary dark:text-secondary">
          Register as <br /> Provider
        </span>
      </button>
    </div>
  );
};

export default SelectOptionComponent;
